<script>
    export let region;
</script>

{#if region === "nz"}
    <div class="alert alert-success" role="alert">
        Set up takes up to 10 minutes. Cashback rewards may be delayed if you make a transaction in that time. We allow linking of up to five cards (Mastercard or Visa - credit or debit). Add or remove cards at any time via the My Account section under Linked Cards.
    </div>
{:else}
    <div class="alert alert-success" role="alert">
        Set up takes up to 10 minutes. Cashback rewards may be delayed if you make a transaction in that time. We allow linking of up to five cards (Mastercard or Visa - credit or debit). Add or remove cards at any time via the My Account section under Linked Cards.
    </div>
{/if}
